export default "__VITE_ASSET__9I3g5W66__"